import ReactModal from "react-modal";
var UserLogin = require("./UserLogin").UserLogin;
import $ from "jquery";

export class LoginModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false
        };
    }

    componentDidMount() {
        $(document).on('LoginUpdated', this.doUpdate.bind(this));
    }

    doUpdate(ev, data) {
        this.setState({
            isOpen: !data.loggedIn
        });
    }

    openModal() {
        this.setState({ isOpen: true });
    }


    handleSubmit(data) {
        this.setState({ isOpen: false });
        this.props.onSubmit(data);
    }

    render() {
        return (
            <ReactModal isOpen={this.state.isOpen} portalClassName="modal-portal" className="modal-dialog" overlayClassName="modal" bodyOpenClassName="modal-open" >
                <div className="modal-content">
                    <div className="bd p-15">
                        <h5 className="m-0">You have been logged out</h5>
                    </div>
                    <div className="modal-body">
                        <UserLogin redirect={false} />
                    </div>
                </div>

               
            </ReactModal>
        );
    }
}